module.exports = __webpack_public_path__ + "img/hr-rock-medium-05.3353326f.png";